import { createSlice } from '@reduxjs/toolkit';
import { fetchLinkedCalendars, unlinkCalendar, startLinkCalendarFlow } from '../thunks/googleCalendarThunks.js';

const initialState = {
    calendars: [],
    loading: false,
    error: '',
};

const googleCalendarSlice = createSlice({
    name: 'googleCalendar',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLinkedCalendars.fulfilled, (state, action) => {
                state.calendars = action.payload;
                state.loading = false;
            })
            .addCase(unlinkCalendar.fulfilled, (state) => {
                state.loading = false;
            })
            .addMatcher(
                (action) => [fetchLinkedCalendars.pending.type, unlinkCalendar.pending.type].includes(action.type),
                (state) => {
                    state.loading = true;
                    state.error = '';
                },
            )
            .addMatcher(
                (action) => [fetchLinkedCalendars.rejected.type, unlinkCalendar.rejected.type].includes(action.type),
                (state, action) => {
                    state.loading = false;
                    state.error = action.payload || action.error?.message || 'Error';
                },
            )
            .addMatcher(
                (action) => [startLinkCalendarFlow.rejected.type].includes(action.type),
                (state, action) => {
                    state.error = action.payload || action.error?.message || 'Error';
                },
            )
            .addDefaultCase((state) => state);
    },
});

export default googleCalendarSlice.reducer;
